import { generateUrl } from '@zenbusiness/zui/SharedAsset';
import { styled, lightTheme } from '@zenbusiness/zui/styles';

const iconCopy = generateUrl('/icon/micro/copy-item-black.svg', 16, 18, 'auto');
const iconCopyHover = generateUrl(
  '/icon/micro/copy-item-black.svg',
  16,
  18,
  'auto',
  null,
  'rgb:095F6D'
);

export const createVgsStyles = (isDesktop) => ({
  color: lightTheme.palette.text.secondary,
  fontSize: isDesktop ? 20 : 16,
  lineHeight: isDesktop ? '24px' : '20px',
  fontFamily: 'Inter',
  fontWeight: '400',
  '@font-face': {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontDisplay: 'swap',
    src: 'url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2")',
    unicodeRange:
      'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
  }
});

export const CopyButtonStyles = {
  background: 'transparent',
  backgroundImage: `url(${iconCopy})`,
  backgroundSize: 'initial',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  cursor: 'pointer',
  width: '30px',
  height: '30px',
  padding: '8px',
  borderRadius: '50%',
  border: 'none',
  '&:hover': {
    backgroundColor: lightTheme.palette.background.grey.main,
    backgroundImage: `url(${iconCopyHover})`
  },
  '&:active': {
    backgroundColor: lightTheme.palette.background.grey.darker
  }
};

export const IconButton = styled('button')(CopyButtonStyles);
